import { navigate } from '../../hooks/useHashRoute';
import { adminRoute, AUSWAHL_ROUTE, editorRoute, SUPERADMIN_ROUTE } from '../../lib/routen';
import type { SessionUser } from '../../net/api';
import { useSessionStore } from '../../stores/sessionStore';
import { useOffice } from '../office/OfficeContext';

/**
 * Die Textlinks der Leiste. Am Schreibtisch stehen sie rechts in der
 * Leiste, auf dem Handy als Liste im Einstellungs-Sheet — derselbe Inhalt,
 * zweimal eingehaengt, per CSS je einmal sichtbar.
 */
export function HudLinks({ user, onAvatar }: { user: SessionUser; onAvatar: () => void }) {
  const logout = useSessionStore((s) => s.logout);
  const { umgebung, istAdmin } = useOffice();
  return (
    <>
      <button className="hud__link" onClick={onAvatar}>
        Avatar
      </button>
      {istAdmin && umgebung.ansichten !== '3d' && (
        <button className="hud__link" onClick={() => navigate(editorRoute(umgebung.id))}>
          Map-Editor
        </button>
      )}
      {istAdmin && (
        <button className="hud__link" onClick={() => navigate(adminRoute(umgebung.id))}>
          Benutzer
        </button>
      )}
      {user.umgebungen.length > 1 && (
        <button className="hud__link" onClick={() => navigate(AUSWAHL_ROUTE)}>
          Umgebung wechseln
        </button>
      )}
      {user.isSuperadmin && (
        <button className="hud__link" onClick={() => navigate(SUPERADMIN_ROUTE)}>
          Superadmin
        </button>
      )}
      <button className="hud__link" onClick={() => void logout()}>
        Abmelden
      </button>
    </>
  );
}
